import { KibContainer } from '@chewy/kib-layout-react'

import { ClinicNotesSection } from '../components/ClinicNotesSection'
import { DeliverySection } from '../components/DeliverySection'
import { MessageBodySection } from '../components/MessageBodySection'
import { PaymentRequestSendErrorBanner } from '../components/PaymentRequestSendErrorBanner'
import { usePaymentRequestDialog } from '../context/PaymentRequestDialogProvider'

import '@chewy/kib-layout-styles/dist/styles/kib-container.css'
import styles from './PaymentRequestScreen.module.scss'

export const PaymentRequestScreen = ({
  isFormValid,
  setIsFormValid,
}: {
  isFormValid: boolean
  setIsFormValid: (isValid: boolean) => void
}) => {
  const { actions, sendError } = usePaymentRequestDialog()

  return (
    <KibContainer className={styles.paymentRequestScreenContainer}>
      {sendError ? (
        <PaymentRequestSendErrorBanner
          errorKind={sendError}
          onDismiss={actions.dismissSendError}
        />
      ) : null}
      <DeliverySection />
      <MessageBodySection />
      <ClinicNotesSection
        isFormValid={isFormValid}
        setIsFormValid={setIsFormValid}
      />
    </KibContainer>
  )
}
